import { render, staticRenderFns } from "./CompDiversityChampionsArticlesSlider.vue?vue&type=template&id=790bee4c"
import script from "./CompDiversityChampionsArticlesSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDiversityChampionsArticlesSlider.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompDiversityChampionsArticlesSlider.vue?vue&type=style&index=0&id=790bee4c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports